// extracted by mini-css-extract-plugin
module.exports = {"stores":"Responsive_stores__2kVZ3","mobile":"Responsive_mobile__wZPCr"};